import type { InputTableFormState } from "../../types/types";

export const inputTableInitialState: InputTableFormState = {
  isLoading: false,
  cols: [],
  isPasteDataFailure: false,
};
